import { render, staticRenderFns } from "./Rincian.vue?vue&type=template&id=74cca7f4&"
import script from "./Rincian.vue?vue&type=script&lang=js&"
export * from "./Rincian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports